module.exports = __webpack_public_path__ + "img/Catalog-tree.d3f412ae.png";